// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Plate$BwaxMobile = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxMobile = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Lang_mod_json$BwaxMobile = require("../../../../bwax-js/ml/lang/mod/builtin/lang_mod_json.bs.js");
var Widget_common$BwaxMobile = require("./widget_common.bs.js");
var Runtime_common$BwaxMobile = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");

var module_name = "Spinner";

var src = "\n\nmodule " + (String(module_name) + ";\n\nimport Element exposing (Rule, Element);\n\nbar: List (Rule msg)\n      -> ~ { height: Int, width: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\nbeat: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nbounce: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\ncircle: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nclimbingBox: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nclip: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nclock: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\ndot: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nfade: List (Rule msg)\n      -> ~ { height: Int, width: Int, radius: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\ngrid: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nhash: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nmoon: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\npacman: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\npropagate: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\npulse: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\npuff: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nring: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nrise: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nrotate: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nscale: List (Rule msg)\n      -> ~ { height: Int, width: Int, radius: Int, margin: Int }  \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nskew: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nsquare: List (Rule msg)\n      -> ~ { size: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\nsync: List (Rule msg)\n      -> ~ { size: Int, margin: Int } \n      -> Color\n      -> Bool \n      -> Element msg = external;\n\n\n\n");

function fail(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function spinner(name) {
  var f = Widget_common$BwaxMobile.pack_element_func(4, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || match.tag !== /* V_list */1) {
              return Runtime_common$BwaxMobile.invalid_args(name);
            } else {
              var match$1 = param[1];
              if (match$1) {
                var match$2 = match$1[1];
                if (match$2) {
                  var match$3 = match$2[1];
                  if (match$3) {
                    var match$4 = match$3[0][0];
                    if (typeof match$4 === "number" || match$4.tag !== /* V_literal */5) {
                      return Runtime_common$BwaxMobile.invalid_args(name);
                    } else {
                      var match$5 = match$4[0];
                      if (typeof match$5 === "number" || !(match$5.tag === /* Bool */4 && !match$3[1])) {
                        return Runtime_common$BwaxMobile.invalid_args(name);
                      } else {
                        var rules = Widget_common$BwaxMobile.raw_to_rules(match[0]);
                        var config = Lang_mod_json$BwaxMobile.any_value_to_json(/* record */[
                              /* keeping_native */true,
                              /* nothing_to_null */true,
                              /* processors : [] */0
                            ], match$1[0]);
                        var color = Widget_common$BwaxMobile.make_color(match$2[0]);
                        return /* Spinner */Block.__(20, [
                                  rules,
                                  name,
                                  config,
                                  color,
                                  match$5[0]
                                ]);
                      }
                    }
                  } else {
                    return Runtime_common$BwaxMobile.invalid_args(name);
                  }
                } else {
                  return Runtime_common$BwaxMobile.invalid_args(name);
                }
              } else {
                return Runtime_common$BwaxMobile.invalid_args(name);
              }
            }
          } else {
            return Runtime_common$BwaxMobile.invalid_args(name);
          }
        }));
  return /* tuple */[
          name,
          f
        ];
}

var externals_vals = Plate$BwaxMobile.List.map(spinner, /* :: */[
      "bar",
      /* :: */[
        "beat",
        /* :: */[
          "bounce",
          /* :: */[
            "circle",
            /* :: */[
              "climbingBox",
              /* :: */[
                "clip",
                /* :: */[
                  "clock",
                  /* :: */[
                    "dot",
                    /* :: */[
                      "fade",
                      /* :: */[
                        "grid",
                        /* :: */[
                          "hash",
                          /* :: */[
                            "moon",
                            /* :: */[
                              "pacman",
                              /* :: */[
                                "propagate",
                                /* :: */[
                                  "pulse",
                                  /* :: */[
                                    "puff",
                                    /* :: */[
                                      "ring",
                                      /* :: */[
                                        "rise",
                                        /* :: */[
                                          "rotate",
                                          /* :: */[
                                            "scale",
                                            /* :: */[
                                              "skew",
                                              /* :: */[
                                                "square",
                                                /* :: */[
                                                  "sync",
                                                  /* [] */0
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var command_handlers = /* [] */0;

exports.module_name = module_name;
exports.src = src;
exports.fail = fail;
exports.spinner = spinner;
exports.externals_vals = externals_vals;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* src Not a pure module */
